import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/inventory/vendors/";

export function getVendors() {
  return http.get(apiEndpoint);
}

export function getVendor(vendorID) {
  return http.get(apiEndpoint + "vendor-detail/" + vendorID);
}

export function getVendorMasterDataAPI() {
  return http.get(apiEndpoint + "vendor-master-data");
}

export function saveVendor(vendor) {
  if (vendor.ID === 0) {
    return http.post(apiEndpoint, vendor);
  } else {
    return http.put(apiEndpoint, vendor);
  }
}

export function saveVendorAddress(address) {
  return http.post(apiEndpoint + "vendor-address", address);
}

export function deleteVendorAddress(addressID) {
  return http.delete(apiEndpoint + "vendor-address/" + addressID);
}

export function getVendorAddress(vendorID) {
  return http.get(apiEndpoint + "vendor-address/" + vendorID);
}

export function saveVendorContact(contact) {
  return http.post(apiEndpoint + "vendor-contact", contact);
}

export function deleteVendorContact(contactID) {
  return http.delete(apiEndpoint + "vendor-contact/" + contactID);
}

export function getVendorContact(vendorID) {
  return http.get(apiEndpoint + "vendor-contact/" + vendorID);
}

export function getVendorContactAccount(contactID) {
  return http.get(apiEndpoint + "vendor-contact-account/" + contactID);
}

export function getVendorContacts() {
  return http.get(apiEndpoint + "vendor-contacts");
}

export function generateSendVendorPortalAccess(contact) {
  return http.post(apiEndpoint + "generate-send-vendor-portal-access", contact);
}

export function saveVendorBankAccount(bankAccount) {
  return http.post(apiEndpoint + "vendor-bank-account", bankAccount);
}

export function deleteVendorBankAccount(bankAccountID) {
  return http.delete(apiEndpoint + "vendor-bank-account/" + bankAccountID);
}

export function getVendorBankAccount(vendorID = 0) {
  return http.get(apiEndpoint + "vendor-bank-account/" + vendorID);
}

export function deleteVendor(vendorID) {
  return http.delete(apiEndpoint + vendorID);
}

export function restoreVendor(vendorID) {
  return http.put(apiEndpoint + vendorID);
}

export function getVendorInvoices(vendorID) {
  return http.get(apiEndpoint + "vendor-invoices/" + vendorID);
}

export function getVendorPayments(vendorID) {
  return http.get(apiEndpoint + "vendor-payments/" + vendorID);
}

export function getVendorQuotations(vendorID) {
  return http.get(apiEndpoint + "vendor-quotations/" + vendorID);
}

export function getVendorPurchaseOrders(vendorID) {
  return http.get(apiEndpoint + "vendor-purchase-orders/" + vendorID);
}

export function getVendorPendingGR(vendorID) {
  return http.get(apiEndpoint + "vendor-pending-gr/" + vendorID);
}
